const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
import floorplan2d1 from './floorplan-2d-1.jpg';
import floorplan2d2 from './floorplan-2d-2.jpg';
import floorplan2d3 from './floorplan-2d-3.jpg';
import floorplan2d4 from './floorplan-2d-4.jpg';
import floorplan3d1 from './floorplan-3d-1.jpg';
import floorplan3d2 from './floorplan-3d-2.jpg';
import floorplan3d3 from './floorplan-3d-3.jpg';
import floorplan3d4 from './floorplan-3d-4.jpg';

const sorted = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const kolovratyRicanumImages: string[] = sorted;

export const kolovratyRicanumFloorPlans = [
  { image: floorplan3d1, label: "Suterén – 3D" },
  { image: floorplan2d1, label: "Suterén – 2D" },
  { image: floorplan3d2, label: "1. NP – 3D" },
  { image: floorplan2d2, label: "1. NP – 2D" },
  { image: floorplan3d3, label: "2. NP – 3D" },
  { image: floorplan2d3, label: "2. NP – 2D" },
  { image: floorplan3d4, label: "Podkroví – 3D" },
  { image: floorplan2d4, label: "Podkroví – 2D" },
];
